import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
export const RowLineTableBodyRow = (props) => {
    const { children, className = '', height, hoverStyle = true } = props;
    return (_jsx("tr", Object.assign({ className: clsx(height || 'h-[90px]', 'border-b border-x-0 border-t-0 border-solid border-light', hoverStyle && 'hover:bg-light-gray', className) }, { children: children })));
};
